(function() {
    var Colors = require('./../../_js-common-modules/colors');

    window.Dashboard = Object.assign({}, window.Dashboard);

    window.Dashboard.Colors = Colors;
})();